import { createGlobalStyle } from "styled-components";
import { reset } from "styled-reset";

const GlobalStyle = createGlobalStyle`
    ${reset}
    *{
        box-sizing: border-box;
        ::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 16px;
        }
        ::-webkit-scrollbar-thumb {
            border-radius: 0px;
            background-color: #666666;
        }
        &:not(input){
            user-select: none;
        }
    }
    html{
        height: 100%;
        min-height: calc(100% + env(safe-area-inset-top));
        font-family: 'DOSMyungjo', serif;
    }
    body{
        width: 100%;
        height: 100%;
        font-size: 16px;
    }
    a{
        color: inherit;
        text-decoration: none;
    }
    input, textarea{
        -webkit-appearance: none;
        font-family: 'DOSMyungjo', serif;
        text-align: center;
        &:focus, &:active{
            outline:none
        }
    }
    img{
        -webkit-user-drag: none;
        user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
    }
    #root{
        width: 100%;
        height: 100%;
    }

    @font-face {
    font-family: 'DOSMyungjo';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_eight@1.0/DOSMyungjo.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}
`;

export default GlobalStyle;
